import './trailingSlash.js'
import './index.css'
import { initMcpInstall } from './mcpInstall'
import { initSiteHeader } from './siteHeader'
import { initSiteFooter } from './siteFooter'

// Hero title: rotating browser names

const HERO_BROWSERS = ['Chrome', 'Safari', 'Firefox']
const HERO_BROWSER_ROTATE_MS = 2600
const HERO_BROWSER_TRANSITION_MS = 320

function initHeroBrowserWord () {
  const word = document.getElementById('hero-browser-word')
  if (!word) return

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

  let index = 0
  let timer = null

  function showNext () {
    word.classList.add('hero__browser-word--exit')
    window.setTimeout(() => {
      index = (index + 1) % HERO_BROWSERS.length
      word.textContent = HERO_BROWSERS[index]
      word.classList.remove('hero__browser-word--exit')
      word.classList.add('hero__browser-word--enter')
      window.setTimeout(() => {
        word.classList.remove('hero__browser-word--enter')
      }, HERO_BROWSER_TRANSITION_MS)
    }, HERO_BROWSER_TRANSITION_MS)
  }

  function start () {
    if (timer) return
    timer = window.setInterval(showNext, HERO_BROWSER_ROTATE_MS)
  }

  function stop () {
    if (!timer) return
    window.clearInterval(timer)
    timer = null
  }

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) stop()
    else start()
  })

  start()
}

// Animated hero UpgradeButton

function animateHeroButton () {
  const wrap = document.getElementById('hero-payhook-btn')
  const btn = document.getElementById('hero-payhook-btn-el')
  const btnLabel = btn?.querySelector('.payhook-btn__label')
  const btnIcon = btn?.querySelector('.payhook-btn__icon')
  const feature = document.getElementById('hero-stage-feature')
  const unlock = document.getElementById('hero-stage-unlock')
  const unlockPanel = document.getElementById('hero-unlock-panel')
  const unlockSuccess = document.getElementById('hero-unlock-success')
  const checkout = document.getElementById('hero-stage-checkout')
  const checkoutPanel = document.getElementById('hero-checkout-panel')
  const checkoutSuccess = document.getElementById('hero-checkout-success')
  const scene = document.querySelector('.hero-stage__scene')
  const paymentFlow = document.getElementById('payment-flow')
  if (!wrap || !btn) return

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  const mobileLanding = window.matchMedia('(max-width: 959px)').matches

  function playTapDemo (mode) {
    if (!scene || !mode) return
    scene.removeAttribute('data-tap-demo')
    void scene.offsetWidth
    scene.setAttribute('data-tap-demo', mode)
  }

  const states = [
    { state: 'upgrade', flowStep: 'chrome', flowDirection: 'forward', label: 'Unlock Pro', hold: 3000, disabled: false, locked: true },
    { state: 'unlock', flowStep: 'payhook', flowDirection: 'forward', unlockStep: 'plans', label: 'Opening...', hold: 2600, disabled: true, locked: true, unlocking: true },
    { state: 'checkout', flowStep: 'stripe', flowDirection: 'forward', checkoutStep: 'form', label: 'Opening...', hold: 2400, disabled: true, locked: true, unlocking: true },
    { state: 'checkout', flowStep: 'stripe', flowDirection: 'forward', checkoutStep: 'success', label: 'Opening...', hold: 1400, disabled: true, locked: true, unlocking: true },
    { state: 'unlock', flowStep: 'payhook', flowDirection: 'reverse', unlockStep: 'success', label: 'Opening...', hold: 2400, disabled: true, locked: true, unlocking: true },
    { state: 'pro', flowStep: 'chrome', flowDirection: 'reverse', label: 'Unlocking...', hold: 1200, disabled: true, locked: true, unlocking: true },
    { state: 'pro', flowStep: 'chrome', flowDirection: 'reverse', label: 'Unlocked', hold: 1800, disabled: true, locked: false },
    { state: 'pro', flowStep: 'chrome', flowDirection: 'forward', label: 'Unlocked', hold: 2600, disabled: true, locked: false }
  ]

  let i = 0
  let timer = null

  function apply (next) {
    wrap.dataset.state = next.state
    btn.disabled = next.disabled
    if (btnLabel) btnLabel.textContent = next.label
    if (btnIcon) btnIcon.hidden = next.state !== 'upgrade' && next.state !== 'pro'
    if (feature) {
      feature.dataset.locked = next.locked ? 'true' : 'false'
      feature.dataset.unlocking = next.unlocking ? 'true' : 'false'
    }
    if (unlock) {
      unlock.hidden = next.state !== 'unlock'
      unlock.dataset.step = next.unlockStep || 'plans'
    }
    if (unlockPanel && unlockSuccess) {
      const isUnlockSuccess = next.unlockStep === 'success'
      unlockPanel.hidden = isUnlockSuccess
      unlockSuccess.hidden = !isUnlockSuccess
    }
    if (checkout) {
      const showCheckout = next.state === 'checkout'
      checkout.hidden = !showCheckout
      checkout.dataset.step = next.checkoutStep || 'form'
    }
    if (checkoutPanel && checkoutSuccess) {
      const isSuccess = next.checkoutStep === 'success'
      checkoutPanel.hidden = isSuccess
      checkoutSuccess.hidden = !isSuccess
    }
    if (next.state === 'upgrade') {
      playTapDemo('upgrade')
    } else if (next.state === 'unlock' && next.unlockStep === 'plans') {
      playTapDemo('unlock-plans')
    } else if (next.state === 'checkout' && next.checkoutStep === 'form') {
      playTapDemo('checkout-form')
    } else if (scene) {
      scene.removeAttribute('data-tap-demo')
    }
    if (paymentFlow) {
      if (next.flowStep) paymentFlow.dataset.activeStep = next.flowStep
      if (next.flowDirection) paymentFlow.dataset.flowDirection = next.flowDirection
    }
  }

  if (reducedMotion || mobileLanding) {
    apply(states[0])
    return
  }

  function tick () {
    apply(states[i])
    timer = window.setTimeout(() => {
      i = (i + 1) % states.length
      tick()
    }, states[i].hold)
  }

  function stop () {
    if (timer) { window.clearTimeout(timer); timer = null }
  }

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) stop()
    else if (!timer) tick()
  })

  tick()
}

function scrollToHash (hash) {
  if (!hash || hash === '#') return
  const target = document.querySelector(hash)
  if (!target) return
  target.scrollIntoView({ behavior: 'smooth', block: 'start' })
}

document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
  anchor.addEventListener('click', (event) => {
    const id = anchor.getAttribute('href')
    if (!id || id === '#') return
    if (!document.querySelector(id)) return
    event.preventDefault()
    scrollToHash(id)
  })
})

if (window.location.hash) {
  window.requestAnimationFrame(() => scrollToHash(window.location.hash))
}

initHeroBrowserWord()
animateHeroButton()

function seedTrustStrip () {
  const track = document.getElementById('trust-strip-track')
  if (!track || track.closest('.trust-strip--chips') || track.classList.contains('landing-proof')) return
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
  const clones = Array.from(track.children).map((li) => li.cloneNode(true))
  clones.forEach((c) => c.setAttribute('aria-hidden', 'true'))
  clones.forEach((c) => track.appendChild(c))
}

seedTrustStrip()

initSiteHeader()
initSiteFooter()
initMcpInstall()
